import { Card, Nav } from "react-bootstrap";
import { useState, useLayoutEffect } from "react";
import { useAppSelector } from "utils/redux/hooks";
import { selectAiFeaturesEnabled } from "app/containers/AdminConsole/slice";
import { useSearchParams } from "react-router-dom";
import NavigateBackButton from "app/components/NavigateBackButton";
import UserEmailAndNotificationSettings from "./UserEmailAndNotificationSettings";
import UserGeneralSettings from "./UserGeneralSettings";
import UserPrivacySettings from "./UserPrivacySettings";

export default function UserSettings() {
  const [searchParams, setSearchParams] = useSearchParams();

  // --------------------------- Selectors ---------------------------
  const areAIFeaturesEnabled = useAppSelector(selectAiFeaturesEnabled);
  // --------------------------- State ---------------------------

  const [tabShowing, setTabShowing] = useState<
    "general" | "privacyAndVisibility" | "emailAndNotifications"
  >("general");

  useLayoutEffect(() => {
    const eventKey = searchParams.get("userSettingsActiveTab");
    if (
      eventKey === "general" ||
      eventKey === "privacyAndVisibility" ||
      eventKey === "emailAndNotifications"
    ) {
      setTabShowing(eventKey);
    }
  }, [searchParams]);

  const getBodyCardContent = () => {
    switch (tabShowing) {
      case "privacyAndVisibility":
        return <UserPrivacySettings />;
      case "emailAndNotifications":
        return <UserEmailAndNotificationSettings />;
      case "general":
      default:
        return <UserGeneralSettings />;
    }
  };

  return (
    <div className="page guide">
      <div className="mb-2">
        <NavigateBackButton />
      </div>
      <div className="column-gap-20px">
        <Card className="column-gap-20px padding-20px">
          <h1>User Settings</h1>
          <Nav
            className="simple-nav"
            activeKey={tabShowing ?? ""}
            onSelect={(e) => {
              if (!e) return;
              setTabShowing(
                e as
                  | "general"
                  | "privacyAndVisibility"
                  | "emailAndNotifications"
              );
              setSearchParams((searchParams) => {
                searchParams.set("userSettingsActiveTab", e);
                return searchParams;
              });
            }}
            style={{
              marginBottom: "-20px",
            }}
          >
            <Nav.Item>
              <Nav.Link eventKey="general">General</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="privacyAndVisibility">
                Privacy/Visibility
              </Nav.Link>
            </Nav.Item>
            {areAIFeaturesEnabled ? (
              <Nav.Item>
                <Nav.Link eventKey="emailAndNotifications">
                  Email/Check-ins
                </Nav.Link>
              </Nav.Item>
            ) : null}
          </Nav>
        </Card>
        <Card className="column-gap-20px padding-20px">
          {getBodyCardContent()}
        </Card>
      </div>
    </div>
  );
}
